import { TransactionType } from 'enum/transaction-type';
import { IUser } from './user';
import { Brokers } from 'enum/brokers';
import { ApiSearchResponseData } from './common';

export interface OrderItem {
  id: null | string;
  requestId: number;
  userId: string;
  brokerId: string;
  orderId: string;
  externalOrderId: string;
  broker: string;
  tradingSymbol: string;
  product: string;
  quantity: number;
  transactionType: string;
  price: number;
  triggerPrice: number;
  orderstatus: string;
  parentOrderId: null | string;
  tradedTime: string;
  user: null | any;
  orderStatus: string;
}

export interface Order {
  requestId: number;
  orderList: OrderItem[];
  placedBy: string;
  placedOn: string;
  price: number;
  quantity: number;
  stockName: string;
  stockId: string;
  transactionType: TransactionType;
  orderType: string;
  triggerPrice: number;
  timestamp: string;
}

export interface IOrderV2 {
  orderId: number;
  firstName: string;
  lastName: string;
  requestId: number;
  userId: string;
  brokerId: string;
  externalOrderId: string;
  broker: string;
  stockId: string;
  product: string;
  quantity: number;
  pendingQuantity: number;
  transactionType: string;
  price: number;
  triggerPrice: number;
  orderStatus: string;
  parentOrderId: any;
  nonDashBoardOrder: boolean;
  placedBy: any;
  stoploss: number;
  orderType: string;
  errorMessage: any;
  strategy: any;
  tradedTime: string;
  createdOn: string;
  user: IUser;
  stockName: string;
  nonDashboardOrder: boolean;
}

export interface OrderSearchResponse extends ApiSearchResponseData {
  searchResponse: IOrderV2[];
}

export enum OrderRequestStatus {
  OPEN = 'open',
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected'
}

export enum OptionType {
  PE = 'PE',
  CE = 'CE'
}

export interface OrderRequest {
  requestId: number;
  userId: string;
  quantity: number;
  stockId: string;
  product: string;
  transactionType: 'BUY' | 'SELL';
  price: number;
  adminId: string;
  stoploss: number;
  orderType: 'LIMIT' | 'MARKET' | 'STOP';
  triggerPrice: number;
  checkForBalance: boolean;
  orderId: number;
  scenarioDisplayName: string;
  scenario: string;
  orderRequestStatus: OrderRequestStatus;
  firstName: string;
  lastName: string;
  brokers: Brokers;
  createdOn: string;
  basketOrder: boolean;
  stockName: string;
  orderRequestList: OrderRequest[];
  optionType: OptionType;
  strikePrice: number;
  requiredMargin: number;
  simulationId: string;
  option: boolean;
  useMTF: boolean;
  accountUseMTF: boolean;
}

export interface StockPosition {
  stockId: string;
  quantity: number;
  price: number;
  pnl: number;
  lastTradedPrice: number;
  intraday: boolean;
  strikePrice: number;
  expectedQuantity: number;
  strategy: string;
  timestamp: string;
  user: IUser;
}

export type OrderPnlMap = Record<string, OrderPnl>;

export interface OrderPnl {
  orderId: number;
  ltp: number;
  pnl: number;
}
